import { apiPyAxios } from "../api/axios";

const unwrap = (res) => res.data?.results ?? res.data ?? [];

/**
 * Fetches attraction blocks and their attractions for a language, grouped per block.
 * Blocks are returned in priority order; only blocks that actually have attractions
 * are included. Pass mainOnly=true to limit attractions to the is_main ones.
 *
 * @param {{ langId: number, mainOnly?: boolean }} opts
 * @returns {Promise<Array<{ id:number, name:string, image:string, attractions:Array }>>}
 */
export const getAttractionData = async (
  { langId, mainOnly = false },
  signal,
) => {
  const [blocksRes, attrsRes] = await Promise.all([
    apiPyAxios.get("attraction-blocks/", {
      params: { lang: langId, page_size: 500 },
      signal,
    }),
    apiPyAxios.get("attractions/", {
      params: {
        lang: langId,
        page_size: 500,
        ...(mainOnly ? { is_main: true } : {}),
      },
      signal,
    }),
  ]);

  const blocks = unwrap(blocksRes);
  const attractions = unwrap(attrsRes);

  const byBlock = {};
  attractions.forEach((a) => {
    (byBlock[a.block] = byBlock[a.block] || []).push(a);
  });

  return blocks
    .map((block) => ({ ...block, attractions: byBlock[block.id] || [] }))
    .filter((block) => block.attractions.length > 0);
};
